module.exports = {
    controller: scheduleBGeneralNotesController,
    templateUrl: 'us/components/schedule-b-general-notes.html'
};

scheduleBGeneralNotesController.$inject = [
    'scheduleBDataService',
    'pdfViewerModal',
];

function scheduleBGeneralNotesController(
    scheduleBDataService,
    pdfViewerModal
) {
    var vm = {
        $onInit: attached,
        openModal: openModal
    };
    return vm;

    function attached() {

    }

    function openModal(fileTitle) {
        scheduleBDataService
            .getScheduleBPdfFile(fileTitle)
            .then(function (fileUrl) {
                pdfViewerModal.show(fileUrl, fileTitle);
            }); 
    }
}